import { apolloClientHolder, createSliceFoundation, getBaseImpures, getBaseReducers, PropsFrom, Utils } from "@crispico/foundation-react";

//@ts-ignore
import lodash from 'lodash';
import React from "react";
import { Button, Container, Segment, List, Image, Modal, Dimmer, Loader, Label, Icon } from "semantic-ui-react";
import { MessageExt } from "@crispico/foundation-react/components/semanticUiReactExt";
import gql from "graphql-tag";
import { SplitPaneExt } from "@crispico/foundation-react/components/ReactSplitPaneExt/ReactSplitPaneExt";
import { ModalExt } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { MapSettings } from "app";
import { MapContainerLeaflet, MarkerData, MARKER_TYPE, sliceMapContainerLeaflet } from "components/MapContainerLeaflet/MapContainerLeaflet";
import { LiveVideo } from "components/LiveVideo/LiveVideo";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { NavLink } from "react-router-dom";
import { GalleryMedia } from "components/LiveVideo/GalleryMedia";
import { PeriodPickerRRC } from "@crispico/foundation-react/components/periodPicker/PeriodPicker";

var moment = require("moment");

export type Video = {
    date: Date,
    thumbnailPath: string,
    videoPath: string
    eventType: string,
    cameraChannel: string,
    entityId: string,
    longitude: number,
    latitude: number,
    duration: number,
}

export const VIDEO_TYPE = "video";

export const FILES_PATH = Utils.adjustUrlToServerContext("public");

export const sliceVideo = createSliceFoundation(class SliceVideo {

    initialState = {
        videos: undefined as unknown as { [key: string]: Video[]; },
        showVideo: false,
        loading: true,
        currentEntityId: undefined as unknown as string
    }

    nestedSlices = {
        mapContainer: sliceMapContainerLeaflet
    }

    reducers = {
        ...getBaseReducers<SliceVideo>(this),
    }

    impures = {
        ...getBaseImpures<SliceVideo>(this),

        onRangePickerChange(infos: any) {
            this.getDispatchers().setInReduxState({ videos: undefined, loading: true, currentEntityId: undefined });
            this.getVideos(Number.parseFloat(infos[2].valueOf()), infos[0].valueOf(), infos[1].valueOf(), infos[3].valueOf());
        },

        async getVideos(equipmentResourceId: any, startDate: any, endDate: any, mapContainerRef: any) {
            const query = gql(`query getVideos($equipmentResourceId: Long!, $startDate: Date, $endDate: Date){
            smartwitnessService_media(
                equipmentResourceId: $equipmentResourceId
                startDate: $startDate
                endDate: $endDate
            ) {date, thumbnailPath, videoPath, eventType, cameraChannel, entityId, latitude, longitude, duration}
          } `);

            mapContainerRef.current?.clearMap();

            const result: Video[] = await (await (await apolloClientHolder.apolloClient.query({ query, variables: { equipmentResourceId, startDate, endDate } }))).data.smartwitnessService_media;
            if (!result || result.length == 0){
                this.getDispatchers().setInReduxState({ videos: undefined, loading: false, currentEntityId: undefined });
                return;
            }
           
            const groupedVideos = {} as { [key: string]: Video[]; }
            result.forEach((video: Video) => {
                groupedVideos[video.entityId] = result.filter(video1 => video.entityId == video1.entityId)
            })
            this.getDispatchers().setInReduxState({ videos: groupedVideos, loading: false, currentEntityId: undefined });

            let data: MarkerData[] = [];
            Object.entries(groupedVideos).forEach(([key, videos]) => {
                let video = videos[0];
                if (video.longitude !== undefined && video.latitude !== undefined &&
                    video.longitude !== null && video.latitude !== null) {
                    data.push({ id: video.entityId, point: { longitude: video.longitude, latitude: video.latitude }, text: video.eventType + " " + moment(video.date).format(Utils.dateTimeWithSecFormat) || "" });
                }
            })
            mapContainerRef.current?.addOrUpdateLayers(data, VIDEO_TYPE);
        },

        selectVideoOnMap(currentKey: string) {
            const current: Video = this.getState().videos[currentKey][0];
            if (current.latitude && current.longitude) {
                this.getDispatchers().mapContainer.setInReduxState({ selectedLayer: { id: current.entityId, type: VIDEO_TYPE, additionalInfo: { flyToLayer: true } } });
            }
            this.getDispatchers().setInReduxState({ currentEntityId: current.entityId })
        },
    }

}, true)

export type Props = PropsFrom<typeof sliceVideo> & {
    equipmentResourceId: any,
    mapSettings: MapSettings,

};

export class VideoTab extends React.Component<Props> {

    private mapContainerRef = React.createRef<MapContainerLeaflet>();

    constructor(props: Props) {
        super(props);
        this.renderMarkerIcon = this.renderMarkerIcon.bind(this)
        this.renderTooltipContent = this.renderTooltipContent.bind(this);
    }

    componentWillUnmount() {
        this.props.dispatchers.setInReduxState({ videos: undefined, currentEntityId: undefined });
    }

    componentDidMount() {
        this.componentDidUpdateInternal();
    }

    componentDidUpdate(prevProps: Props) {
        this.componentDidUpdateInternal(prevProps);
    }

    componentDidUpdateInternal(prevProps?: Props) {
        if (!lodash.isEqual(prevProps?.mapContainer.selectedLayer, this.props.mapContainer.selectedLayer) && prevProps) {
            let id = this.props.mapContainer.selectedLayer?.id;
            if (id != undefined) {
                document.getElementById(id.toString())?.scrollIntoView();
                this.props.dispatchers.setInReduxState({ currentEntityId: id.toString() });
            }
        }
    }

    renderMarkerIcon(markerData: MarkerData): React.ReactNode {
        return <span className='fa fa-stack fa-lg'><i className={'fa-solid fa-video-camera fa-stack-1x'} ></i></span>   
    }

    renderTooltipContent(markerData: MarkerData): React.ReactElement {
        return <div className="flex-container">{markerData.text}</div>;
    }

    render() {
        return <>
            <div className="flex-container flex-center">
                <Segment basic className="flex-container-row flex-center flex-grow-shrink-no-overflow less-padding no-margin" style={{ width: '100%' }}>
                    <MessageExt className="flex-grow">
                        <PeriodPickerRRC id="periodPicker" onChange={(startDate, endDate) => this.props.dispatchers.onRangePickerChange([startDate, endDate, this.props.equipmentResourceId, this.mapContainerRef])} />
                        <span className="float-right"><LiveVideo entityId={this.props.equipmentResourceId} /></span>
                    </MessageExt>
                </Segment>
            </div>
            <SplitPaneExt minSize={250} size="50%" >
                <Container className="wh80">
                    <Dimmer active={this.props.loading} ><Loader size="big">{_msg("general.loading")}</Loader></Dimmer>
                    <List className="flex-grow-shrink-no-overflow less-padding no-margin" divided relaxed>
                        {this.props.videos ? Object.entries(this.props.videos).sort((a,b) => {
                            // sort desc by date
                            return a[1][0].date < b[1][0].date ? 1 : a[1][0].date > b[1][0].date ? -1 : 0
                        }).map(([key, videos]) => {
                            // copy videos because of state and sort videos by cameraChannel to show always thumbnail of camera 1 if exists
                            let videosCopy = [...videos]
                            videosCopy.sort((a,b) => a.cameraChannel.localeCompare(b.cameraChannel));
                            let video = videosCopy[0]
                            return (
                                <List.Item id={video.entityId} onClick={() => this.props.dispatchers.selectVideoOnMap(key)} style={{ background: this.props.currentEntityId === video.entityId ? "lightgrey" : undefined }}>
                                   <VideoElement video={video} onClickPlayButton={() => this.props.dispatchers.setInReduxState({showVideo: true})}/>
                                </List.Item>
                            )
                        })
                            : null
                        }
                    </List>
                    <ModalExt open={this.props.showVideo} style={{ width: '95%', height: '95%', background: 'black' }} onClose={() => this.props.dispatchers.setInReduxState({ showVideo: false })} >
                        <Modal.Content className="wh100">
                            <GalleryMedia data={processVideosToGalleryImagesData(this.props.videos, this.props.currentEntityId)} loading={false} video={true}
                                extraInfo={this.props.videos && this.props.currentEntityId ?
                                     this.props.videos[this.props.currentEntityId][0].eventType + " " + moment(this.props.videos[this.props.currentEntityId][0].date).format(Utils.dateTimeWithSecFormat)
                                     : undefined}/>
                        </Modal.Content>
                    </ModalExt>
                </Container>
                <div className="no-padding-margin flex-container flex-grow-shrink-no-overflow MapRealTime_topParent" >
                    <MapContainerLeaflet {...this.props.mapContainer} dispatchers={this.props.dispatchers.mapContainer}
                        ref={this.mapContainerRef} pruneClusterMode={false} saveCenterZoomInStorage={true}
                        renderTooltipContent={this.renderTooltipContent} renderMarkerIcon={this.renderMarkerIcon}
                        bingAPIKey={this.props.mapSettings.bingAPIKey} mapId={"map-videos"}
                        layers={{ [VIDEO_TYPE]: { layerType: MARKER_TYPE } }} />
                </div>
            </SplitPaneExt></>

    }
}
export class VideoElement extends React.Component<{ video: Video, onClickPlayButton: () => void }> {
    render() {
        const video = this.props.video;
        return (<>
            <Button icon circular size="medium" style={{ transform: 'translate(-5%, 70%)' }} className="right floated margin" onClick={() => this.props.onClickPlayButton()}>
                <Icon name="play" color="red" />
            </Button>
            <Image src={FILES_PATH + video.thumbnailPath} size="small" rounded />
            <List.Content>
                <List.Header>{_msg("general.date")}: {moment(video.date).format(Utils.dateTimeWithSecFormat)}</List.Header>
                <List.Description>{_msg("DrivingEvent.type.label")}: {video.eventType}</List.Description>
                <List.Description>{_msg("Smartwitness.location")}: [{video.longitude}, {video.latitude}]</List.Description>
                <List.Description>{_msg("general.duration")}: {moment.duration(video.duration, "seconds").format()} </List.Description>
                <List.Description>
                    <NavLink to={entityDescriptors["DrivingEvent"].getEntityEditorUrl(video.entityId)}>
                        <Label icon size="small">
                            {_msg("Smartwitness.showEvent")}
                            &nbsp;&nbsp;
                            <Icon name="share" />
                        </Label>
                    </NavLink>
                </List.Description>
            </List.Content>
        </>
        )
    }
}

export function processVideosToGalleryImagesData(videos: { [key: string]: Video[]; }, currentKey?: string): { [key: string]: string; } | undefined {
    if (!videos || !currentKey){
        return
    }

    const currentVideoGroup = {} as { [key: string]: string; }
    videos[currentKey]?.forEach((video) => {
        currentVideoGroup[video.cameraChannel] = FILES_PATH + video.videoPath;
    })

    return currentVideoGroup
}